import React from "react";
import { CiImageOn } from "react-icons/ci";
import colorIcon from "../../assets/color_icon.svg";

export const NotificationCard = ({ title, description, mediaImages, fileUrl, primaryBtnText, url }) => {

    return (
        <div className="w-full bg-white p-4 flex flex-col lg:flex-row items-start justify-between gap-4 rounded-2xl shadow-sm mt-5">
            {/* Left Content */}
            <div className="w-full flex flex-col items-start justify-start">
                {/* Icon + Title */}
                        <div className="flex items-start justify-start gap-3">
                            <div className="w-10 h-10 bg-primary rounded-[10px] flex items-center justify-center flex-shrink-0">
                                <img src={colorIcon} alt="Icon" />
                            </div>
                            <span className="text-black text-base sm:text-lg md:text-xl lg:text-2xl font-bold font-grotesk leading-snug">
                                {title}
                            </span>
                        </div>

                {/* Description + Images */}
                <div className="max-w-full lg:max-w-[640px] mt-2 lg:mt-1">
                    <p className="text-sm sm:text-[16px] text-[#696565] font-medium font-grotesk leading-relaxed">
                        {description}
                    </p>

                    {/* Images */}
                    <div className="w-full flex items-center justify-center sm:justify-start gap-2 mt-3 flex-wrap">
                        {mediaImages && mediaImages.length > 0 ? (
                            mediaImages.map((media, index) => (
                                <div key={index} className="relative flex-1 max-w-[140px] h-[140px] sm:max-w-[160px] sm:h-[160px]">
                                    <div className="w-full h-full bg-white rounded-xl overflow-hidden flex items-center justify-center border border-gray-200">
                                        <img 
                                            src={fileUrl + media.file_name} 
                                            alt={`Preview ${index + 1}`} 
                                            className="w-full h-full object-cover" 
                                        />
                                    </div>
                                </div>
                            ))
                        ) : (
                            <div className="relative flex-1 max-w-[140px] h-[140px] sm:max-w-[160px] sm:h-[160px]">
                                <div className="w-full h-full bg-white rounded-xl overflow-hidden flex items-center justify-center border border-gray-200">
                                    <CiImageOn className="text-6xl sm:text-8xl text-gray-300" />
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {/* Buttons */}
            <div className="flex flex-col sm:flex-row items-stretch gap-3 w-full sm:w-auto">
                {primaryBtnText && url && (
                    <a 
                        href={url} 
                        className="text-xs sm:text-sm font-bold text-white font-grotesk border bg-primary py-2 sm:py-3 px-4 sm:px-5 rounded-[10px] whitespace-nowrap min-w-[120px] sm:min-w-[160px] inline-block text-center hover:bg-primary-dark transition-colors"
                    >
                        {primaryBtnText}
                    </a>
                )}
            </div>
        </div>
    );
};
